import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "./contexts/LanguageContext";
import { Header } from "./components/Header";
import { HeroSection } from "./components/HeroSection";
import { ContactPersonSection } from "./components/ContactPersonSection";
import { LeadHookSection } from "./components/LeadHookSection";
import { PackagesSection } from "./components/PackagesSection";
import { HowItWorksSection } from "./components/HowItWorksSection";
import { LeadFormSection } from "./components/LeadFormSection";
import { FinalCtaSection } from "./components/FinalCtaSection";
import { TestimonialsSection } from "./components/TestimonialsSection";
import { Footer } from "./components/Footer";
import { WhatsAppButton } from "./components/WhatsAppButton";
import { AboutPage } from "./components/AboutPage";
import { PortfolioPage } from "./components/PortfolioPage";

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-background" data-testid="landing-page">
      <Header />
      <main>
        <HeroSection />
        <ContactPersonSection />
        <LeadHookSection />
        <TestimonialsSection />
        <PackagesSection />
        <HowItWorksSection />
        <LeadFormSection />
        <FinalCtaSection />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <Toaster position="top-center" richColors />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/portfolio" element={<PortfolioPage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;
